import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m ? m[1] : null;
    (async () => {
      try {
        const r = await api.post("/auth/session", null, { headers: { "X-Session-ID": sid } });
        setUser(r.data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: r.data } });
      } catch {
        setUser(false);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);
  return null;
}
